import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root',
})
export class UserService {
  // userEmail
  constructor() {}
  
  saveLoginInfo(email) {
  
  }
  // showSliderOnce(sliderShown) {
  //   this.storage.set('sliderInfo', sliderShown).then((res) => {
  //     console.log(res);
  //   });
  // }
 
}
